import type { TrpcRouter } from '@rolebase/backend'
import { createTRPCClient, httpBatchLink } from '@trpc/client'
import { nhost } from './nhost'
import settings from './settings'

export const trpc = createTRPCClient<TrpcRouter>({
  links: [
    httpBatchLink({
      url: settings.backendUrl,
      // Auth with Nhost — refresh token if expiring within 60s
      async headers() {
        const session = await nhost.refreshSession(60)
        const token =
          session?.accessToken ??
          nhost.sessionStorage.get()?.accessToken
        return token ? { Authorization: `Bearer ${token}` } : {}
      },
    }),
  ],
})
